
import React from 'react';
import '../CSSFiles/header.css';
import '../CSSFiles/footer.css';
import '../CSSFiles/socialmedia.css';
import '../CSSFiles/blogTemplate.css';

const ComingSoonBlog = props => {
  return (
    // <div className="blog-container">
    //   <header className="blog-header">
    //     <h2 className="blog-title">What Are We Designed To Eat?</h2>
    //   </header>

    //   <div className="blog-content">
    //     <article className="blog-post">
    //         <h1 id='blue'>Coming soon</h1>
    //     </article>
    //   </div>
    // </div>

<div className="blog-container-soon">

<div className="blog-content">
  <article className="blog-post">
    <br />
    <br />
    <br />
    <br />
    <br />
    <h1>Coming soon...</h1>
    <br />
    <br />
    <br />
    <br />
    <br />
  </article>
</div>
</div>
  );
}

export default ComingSoonBlog;
